// extracted by mini-css-extract-plugin
module.exports = {"container":"Section_container__3md8M"};